import React from 'react';
import styles from './styles.module.css';
import classNames from 'classnames';

type Props = {
  children: React.ReactNode;
  fullWidth?: boolean;
};

function RadioGroupContainer({ children, fullWidth = false }: Props) {
  const containerClasses = classNames(styles.radioGroup, {
    [styles.fullWidth]: fullWidth,
  });
  return <div className={containerClasses}>{children}</div>;
}

export default RadioGroupContainer;
